import { Dispatch } from "redux";
import { UserDataActions } from "./index";
import { Entities, PropertyRegistryApi } from "@10x/dubai-rest-api";
import EjariApi from "@eres/ejari-api";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { getToken } from "@my-dld/utils/User";
import { MollakMeydaanAPI } from "@my-dld/screens/MyDLD/Portfolio/MollakMeydaanAPI";

export function loadMapProperties() {
	return ( dispatch: Dispatch ) => {
		dispatch( {
			type: UserDataActions.ON_MAP_PROPERTIES_LOADING,
		} );
		MollakMeydaanAPI.getProperties()
		.then( ( r: any ) => {
			dispatch( {
				type: UserDataActions.ON_MAP_PROPERTIES,
				payload: r?.properties
			} );
		} ).catch( r => {
			dispatch( {
				type: UserDataActions.ON_MAP_PROPERTIES,
				payload: undefined,
			} );
		} );
	};
}

export function loadAssets() {
	return ( dispatch: Dispatch ) => {
		dispatch( {
			type: UserDataActions.ON_PROPERTIES_LOADING
		} );
		PropertyRegistryApi.loadAllAssetsSplit().then( Entities.validateResponse )
		.then( r => {
			dispatch( {
				type: UserDataActions.ON_PROPERTIES,
				payload: r
			} );
		} ).catch( r => {
			dispatch( {
				type: UserDataActions.ON_PROPERTIES,
				payload: undefined,
			} );
		} );
	};
}

export function loadLeases( eid: string ) {
	return ( dispatch: Dispatch ) => {
		dispatch( {
			type: UserDataActions.ON_LEASE_LOADING
		} );
		EjariApi.getMyLeases( "", eid )
		.then( r => {
			dispatch( {
				type: UserDataActions.ON_LEASE,
				payload: r.Leases
			} );
		} )
		.catch( r => {
			dispatch( {
				type: UserDataActions.ON_LEASE,
				payload: undefined,
			} );

		} );
	};
}

export function downloadTenancyContract( property: EjariProperty ) {
	let contractNumber = property?.CurrentContract?.ContractNumber;
	let contractKey = property?.CurrentContract?.ContractKey;
	if ( contractNumber && contractKey )
		downloadTenancyContractByNumber( contractNumber, contractKey );
}

export function downloadTenancyContractByNumber( contractNumber: string, key: string ) {
	if ( contractNumber && key ) {
		showLoading();
		var params = {
			token: getToken() ?? "",
		};

		fetch( EjariApi.getDownloadPDFurl( key ), { headers: params } ).then( r => r.blob() )
		.then( blob => {
			let newBlob = new Blob( [ blob ], { type: "application/pdf" } );
			let url = window.URL.createObjectURL( newBlob );
			let a = document.createElement( "a" );
			a.href = url;
			a.download = contractNumber + ".pdf";
			a.click();
			trackEventWithData( "Ejari", "DownloadContract", { contractNumber: contractNumber + "" } );
			hideLoading();
		} ).catch( e => hideLoading() );
	}

}

function showFile( blob: any, fileName: string ) {
	// It is necessary to create a new blob object with mime-type explicitly set
	// otherwise only Chrome works like it should
	var newBlob = new Blob( [ blob ], { type: "application/pdf" } );

	// IE doesn't allow using a blob object directly as link href
	// instead it is necessary to use msSaveOrOpenBlob
	if ( window.navigator && window.navigator.msSaveOrOpenBlob ) {
		window.navigator.msSaveOrOpenBlob( newBlob );
		return;
	}

	// For other browsers:
	// Create a link pointing to the ObjectURL containing the blob.
	const data = window.URL.createObjectURL( newBlob );
	var link = document.createElement( "a" );
	link.href = data;
	link.download = fileName + ".pdf";
	link.click();
	setTimeout( function () {
		// For Firefox it is necessary to delay revoking the ObjectURL
		window.URL.revokeObjectURL( data );
	}, 100 );
}

